export const resolveAsFunction = function resolveAsFunction(value) {
    if (typeof value === "function") {
        return value
    }
    return () => value
}
